/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadHchbDocumentsRequest
 */
export interface UploadHchbDocumentsRequest {
    /**
     * 
     */
    push_insurance_eligibility_check_results?: boolean;
    /**
     * 
     */
    push_clinic_package?: boolean;
    /**
     * 
     */
    push_full_clinic_package?: boolean;
    /**
     * 
     */
    clinic_package_document_ids?: Array<string>;
    /**
     * 
     */
    push_generated_document_types?: Array<UploadHchbDocumentsRequestPushGeneratedDocumentTypesEnum>;
    /**
     * 
     */
    push_additional_document_ids?: Array<string>;
    /**
     * MatrixCare Home Health DocumentTypeUploadID (GUID from the MC HH
     * lookups response). Required when external_ehr_type is
     * MATRIX_CARE_HOME_HEALTH; applied to every doc in this upload batch.
     * 
     */
    matrix_care_home_health_document_type_id?: string;
}


/**
 * @export
 */
export const UploadHchbDocumentsRequestPushGeneratedDocumentTypesEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PalCarveOutsPackage: 'pal_carve_outs_package',
    PalReauthSubmissionPackage: 'pal_reauth_submission_package',
    PdpmReport: 'pdpm_report',
    PccFaceSheetReport: 'pcc_face_sheet_report',
    PccOrderSummaryReport: 'pcc_order_summary_report',
    PccMdHistoryReport: 'pcc_md_history_report',
    PccDailySkilledNoteReport: 'pcc_daily_skilled_note_report',
    PccProgressNotesReport: 'pcc_progress_notes_report',
    PccWeightsVitalsReport: 'pcc_weights_vitals_report',
    PccLabResultsReport: 'pcc_lab_results_report',
    PccSocialServicesReport: 'pcc_social_services_report',
    PccSkinCheckReport: 'pcc_skin_check_report',
} as const;
export type UploadHchbDocumentsRequestPushGeneratedDocumentTypesEnum = typeof UploadHchbDocumentsRequestPushGeneratedDocumentTypesEnum[keyof typeof UploadHchbDocumentsRequestPushGeneratedDocumentTypesEnum];


/**
 * Check if a given object implements the UploadHchbDocumentsRequest interface.
 */
export function instanceOfUploadHchbDocumentsRequest(value: object): value is UploadHchbDocumentsRequest {
    return true;
}

export function UploadHchbDocumentsRequestFromJSON(json: any): UploadHchbDocumentsRequest {
    return UploadHchbDocumentsRequestFromJSONTyped(json, false);
}

export function UploadHchbDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadHchbDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'push_insurance_eligibility_check_results': json['push_insurance_eligibility_check_results'] == null ? undefined : json['push_insurance_eligibility_check_results'],
        'push_clinic_package': json['push_clinic_package'] == null ? undefined : json['push_clinic_package'],
        'push_full_clinic_package': json['push_full_clinic_package'] == null ? undefined : json['push_full_clinic_package'],
        'clinic_package_document_ids': json['clinic_package_document_ids'] == null ? undefined : json['clinic_package_document_ids'],
        'push_generated_document_types': json['push_generated_document_types'] == null ? undefined : json['push_generated_document_types'],
        'push_additional_document_ids': json['push_additional_document_ids'] == null ? undefined : json['push_additional_document_ids'],
        'matrix_care_home_health_document_type_id': json['matrix_care_home_health_document_type_id'] == null ? undefined : json['matrix_care_home_health_document_type_id'],
    };
}

export function UploadHchbDocumentsRequestToJSON(json: any): UploadHchbDocumentsRequest {
    return UploadHchbDocumentsRequestToJSONTyped(json, false);
}

export function UploadHchbDocumentsRequestToJSONTyped(value?: UploadHchbDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'push_insurance_eligibility_check_results': value['push_insurance_eligibility_check_results'],
        'push_clinic_package': value['push_clinic_package'],
        'push_full_clinic_package': value['push_full_clinic_package'],
        'clinic_package_document_ids': value['clinic_package_document_ids'],
        'push_generated_document_types': value['push_generated_document_types'],
        'push_additional_document_ids': value['push_additional_document_ids'],
        'matrix_care_home_health_document_type_id': value['matrix_care_home_health_document_type_id'],
    };
}

